const ConfigureRoleForm = ({
  popup,
  setPopup,
  role,
  setRole,
  processData,
  error,
  setError,
  action,
  permissions,
}) => {
  return (
    <div
      className={
        popup === "add" || popup === "edit"
          ? "modal fade show d-block"
          : "modal fade"
      }
      tabIndex={-1}
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {popup === "add" ? "Add New" : "Update"} Role
            </h5>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-12 mb-5">
                <div className="fv-row fv-plugins-icon-container fv-plugins-bootstrap5-row-invalid">
                  {/*begin::Input*/}
                  <label className="form-label required">Role Name</label>
                  <input
                    autoComplete="off"
                    className="form-control"
                    placeholder="Enter Name"
                    value={role?.name ?? ""}
                    onChange={(e) => {
                      processData("text", e, "name");
                    }}
                  />
                  <small className="text-danger mt-2">
                    {error?.name ?? ""}
                  </small>
                  {/*end::Input*/}
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <h6 className="text-gray-800 mb-3">Permissions</h6>
                <div className="form-check form-check-sm">
                  <input
                    value="all"
                    checked={
                      permissions?.every((permission) =>
                        role?.permissions?.includes(permission),
                      ) ?? false
                    }
                    onChange={(e) => {
                      processData("permissions", e, "permissions");
                    }}
                    className="form-check-input me-3"
                    type="checkbox"
                  />
                  <label className="form-check-label">
                    <div className="fw-bold text-gray-800">
                      Grant All Permissions
                    </div>
                  </label>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Driver Map</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_map"
                        checked={
                          role?.permissions?.includes("view_driver_map") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="filter_driver_map"
                        checked={
                          role?.permissions?.includes("filter_driver_map") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Filter</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Ongoing Orders</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_ongoing_orders"
                        checked={
                          role?.permissions?.includes("view_ongoing_orders") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Ongoing Orders
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_daily_order_stat"
                        checked={
                          role?.permissions?.includes(
                            "view_daily_order_stat",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Daily Order Stat
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_delayed_order_event"
                        checked={
                          role?.permissions?.includes(
                            "view_delayed_order_event",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Delayed Order Events
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Merchant</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_list"
                        checked={
                          role?.permissions?.includes("view_merchant_list") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_details"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_details",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Details
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_branch"
                        checked={
                          role?.permissions?.includes("view_merchant_branch") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View Branch</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_merchant_branch"
                        checked={
                          role?.permissions?.includes("add_merchant_branch") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Add Branch</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_merchant_branch"
                        checked={
                          role?.permissions?.includes("edit_merchant_branch") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Edit Branch</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_merchant_branch"
                        checked={
                          role?.permissions?.includes(
                            "delete_merchant_branch",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Branch
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_contact"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_contact",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Contact
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_merchant_contact"
                        checked={
                          role?.permissions?.includes("add_merchant_contact") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Add Contact</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_merchant_contact"
                        checked={
                          role?.permissions?.includes(
                            "edit_merchant_contact",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Contact
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_merchant_contact"
                        checked={
                          role?.permissions?.includes(
                            "delete_merchant_contact",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Contact
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_employees"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Employees
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_merchant_employees"
                        checked={
                          role?.permissions?.includes(
                            "add_merchant_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Add Employees
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_merchant_employees"
                        checked={
                          role?.permissions?.includes(
                            "edit_merchant_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Employees
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_merchant_employees"
                        checked={
                          role?.permissions?.includes(
                            "delete_merchant_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Employees
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="reset_password_merchant_employees"
                        checked={
                          role?.permissions?.includes(
                            "reset_password_merchant_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Reset Employee Password
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_wallet_balance"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_wallet_balance",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Wallet Balance
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="topup_merchant_wallet_balance"
                        checked={
                          role?.permissions?.includes(
                            "topup_merchant_wallet_balance",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Topup Wallet Balance
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="deduct_merchant_wallet_balance"
                        checked={
                          role?.permissions?.includes(
                            "deduct_merchant_wallet_balance",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Deduct Wallet Balance
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="manage_merchant_credit_card_topup"
                        checked={
                          role?.permissions?.includes(
                            "manage_merchant_credit_card_topup",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Manage Credit Card Topup
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_api_keys"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_api_keys",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View API Key
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="download_merchant_api_keys"
                        checked={
                          role?.permissions?.includes(
                            "download_merchant_api_keys",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Download API Key
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="regenerate_merchant_api_keys"
                        checked={
                          role?.permissions?.includes(
                            "regenerate_merchant_api_keys",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Regenerate API Key
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_transactions"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_transactions",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Transaction
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="export_merchant_transactions"
                        checked={
                          role?.permissions?.includes(
                            "export_merchant_transactions",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Export Transaction
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_merchant_details"
                        checked={
                          role?.permissions?.includes(
                            "edit_merchant_details",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Merchant Details
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="suspend_merchant"
                        checked={
                          role?.permissions?.includes("suspend_merchant") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Suspend Merchant
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="activate_merchant"
                        checked={
                          role?.permissions?.includes("activate_merchant") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Activate Merchant
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_merchant"
                        checked={
                          role?.permissions?.includes("delete_merchant") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Merchant
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_new_merchant"
                        checked={
                          role?.permissions?.includes("create_new_merchant") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Create Merchant
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_group"
                        checked={
                          role?.permissions?.includes("view_merchant_group") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Merchant Group
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_merchant_group"
                        checked={
                          role?.permissions?.includes(
                            "create_merchant_group",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Create Merchant Group
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_merchant_group"
                        checked={
                          role?.permissions?.includes("edit_merchant_group") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Merchant Group
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_merchant_group"
                        checked={
                          role?.permissions?.includes(
                            "delete_merchant_group",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Merchant Group
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="download_pricing_sheet"
                        checked={
                          role?.permissions?.includes(
                            "download_pricing_sheet",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Download Pricing Sheet
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_all_merchants_transaction_list"
                        checked={
                          role?.permissions?.includes(
                            "view_all_merchants_transaction_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View All Merchant Transactions
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_notifications"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_notifications",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Merchant Notifications
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_merchant_notifications"
                        checked={
                          role?.permissions?.includes(
                            "create_merchant_notifications",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Create Merchant Notification
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_merchant_notifications"
                        checked={
                          role?.permissions?.includes(
                            "edit_merchant_notifications",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Merchant Notification
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="activate_merchant_notifications"
                        checked={
                          role?.permissions?.includes(
                            "activate_merchant_notifications",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Activate Merchant Notification
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="deactivate_merchant_notifications"
                        checked={
                          role?.permissions?.includes(
                            "deactivate_merchant_notifications",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Deactivate Merchant Notification
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_merchant_notifications"
                        checked={
                          role?.permissions?.includes(
                            "delete_merchant_notifications",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Merchant Notification
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Driver</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_list"
                        checked={
                          role?.permissions?.includes("view_driver_list") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_details"
                        checked={
                          role?.permissions?.includes("view_driver_details") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Details
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="change_driver_custom_sharing"
                        checked={
                          role?.permissions?.includes(
                            "change_driver_custom_sharing",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Change Custom Sharing
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_performance"
                        checked={
                          role?.permissions?.includes(
                            "view_driver_performance",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Performance
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_driver_details"
                        checked={
                          role?.permissions?.includes("edit_driver_details") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Edit Driver</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="suspend_driver"
                        checked={
                          role?.permissions?.includes("suspend_driver") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Suspend Driver
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="activate_driver"
                        checked={
                          role?.permissions?.includes("activate_driver") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Activate Driver
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="mark_driver_busy"
                        checked={
                          role?.permissions?.includes("mark_driver_busy") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Mark Driver Busy
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="mark_driver_free"
                        checked={
                          role?.permissions?.includes("mark_driver_free") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Mark Driver Free
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="reset_driver_password"
                        checked={
                          role?.permissions?.includes(
                            "reset_driver_password",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Reset Driver Password
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_driver"
                        checked={
                          role?.permissions?.includes("delete_driver") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Driver
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_new_driver"
                        checked={
                          role?.permissions?.includes("create_new_driver") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Create Driver
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Order</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_order_list"
                        checked={
                          role?.permissions?.includes("view_order_list") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_order_details"
                        checked={
                          role?.permissions?.includes("view_order_details") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Details
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="cancel_order"
                        checked={
                          role?.permissions?.includes("cancel_order") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Cancel Order
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="mark_complete_order"
                        checked={
                          role?.permissions?.includes("mark_complete_order") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Mark Order Completed
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="mark_scanned_order"
                        checked={
                          role?.permissions?.includes("mark_scanned_order") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Mark Order Scanned
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="order_force_dispatch"
                        checked={
                          role?.permissions?.includes("order_force_dispatch") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Force Dispatch
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_order"
                        checked={
                          role?.permissions?.includes("edit_order") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Edit Order</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_order_log"
                        checked={
                          role?.permissions?.includes("view_order_log") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Order Log
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Delivery Company</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_delivery_company_list"
                        checked={
                          role?.permissions?.includes(
                            "view_delivery_company_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_delivery_company_details"
                        checked={
                          role?.permissions?.includes(
                            "view_delivery_company_details",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Details
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_delivery_company_driver_list"
                        checked={
                          role?.permissions?.includes(
                            "view_delivery_company_driver_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Driver List
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_delivery_company_employees"
                        checked={
                          role?.permissions?.includes(
                            "view_delivery_company_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Company Employees
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_delivery_company_employees"
                        checked={
                          role?.permissions?.includes(
                            "add_delivery_company_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Add New Employee
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_delivery_company_employees"
                        checked={
                          role?.permissions?.includes(
                            "edit_delivery_company_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Employee Details
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_delivery_company_employees"
                        checked={
                          role?.permissions?.includes(
                            "delete_delivery_company_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Employee
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="reset_password_delivery_company_employees"
                        checked={
                          role?.permissions?.includes(
                            "reset_password_delivery_company_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Reset Employee Password
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_delivery_company"
                        checked={
                          role?.permissions?.includes(
                            "edit_delivery_company",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Delivery Company
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_delivery_company"
                        checked={
                          role?.permissions?.includes(
                            "delete_delivery_company",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Delivery Company
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_delivery_company"
                        checked={
                          role?.permissions?.includes(
                            "create_delivery_company",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Create Delivery Company
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Merchant Archive</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_merchant_archive_list"
                        checked={
                          role?.permissions?.includes(
                            "view_merchant_archive_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="restore_archived_merchant"
                        checked={
                          role?.permissions?.includes(
                            "restore_archived_merchant",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Restore</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Driver Archive</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_archive_list"
                        checked={
                          role?.permissions?.includes(
                            "view_driver_archive_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="restore_archived_driver"
                        checked={
                          role?.permissions?.includes(
                            "restore_archived_driver",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Restore</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Employee Archive</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_employees_archive_list"
                        checked={
                          role?.permissions?.includes(
                            "view_employees_archive_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="restore_archived_employees"
                        checked={
                          role?.permissions?.includes(
                            "restore_archived_employees",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Restore</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Delivery Company Archive</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_delivery_company_archive_list"
                        checked={
                          role?.permissions?.includes(
                            "view_delivery_company_archive_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="restore_archived_delivery_company"
                        checked={
                          role?.permissions?.includes(
                            "restore_archived_delivery_company",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Restore</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">User Role</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_user_role_list"
                        checked={
                          role?.permissions?.includes("view_user_role_list") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Role List
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_new_user_role"
                        checked={
                          role?.permissions?.includes("add_new_user_role") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Add New Role
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_user_role"
                        checked={
                          role?.permissions?.includes("edit_user_role") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Edit Role</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_user_role"
                        checked={
                          role?.permissions?.includes("delete_user_role") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Delete Role</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Admin User</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_admin_user"
                        checked={
                          role?.permissions?.includes("view_admin_user") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View User List
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_admin_user"
                        checked={
                          role?.permissions?.includes("add_admin_user") ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Add New User
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_admin_user"
                        checked={
                          role?.permissions?.includes("edit_admin_user") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Edit User</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="deactivate_admin_user"
                        checked={
                          role?.permissions?.includes(
                            "deactivate_admin_user",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Deactivate User
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="activate_admin_user"
                        checked={
                          role?.permissions?.includes("activate_admin_user") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Activate User
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="reset_admin_user_password"
                        checked={
                          role?.permissions?.includes(
                            "reset_admin_user_password",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Reset Password
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Driver Revenue Sharing</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_revenue_sharing_setting"
                        checked={
                          role?.permissions?.includes(
                            "view_driver_revenue_sharing_setting",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Driver Revenue Sharing
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_driver_revenue_sharing_setting"
                        checked={
                          role?.permissions?.includes(
                            "edit_driver_revenue_sharing_setting",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Driver Revenue Sharing
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Low Balance Alert</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_low_balance_alert_setting"
                        checked={
                          role?.permissions?.includes(
                            "view_low_balance_alert_setting",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Low Balance Alert
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_low_balance_alert_setting"
                        checked={
                          role?.permissions?.includes(
                            "edit_low_balance_alert_setting",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit Low Balance Alert
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Pricing Model</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_pricing_model_list"
                        checked={
                          role?.permissions?.includes(
                            "view_pricing_model_list",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View List</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_pricing_model"
                        checked={
                          role?.permissions?.includes("edit_pricing_model") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Edit</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_pricing_model"
                        checked={
                          role?.permissions?.includes("delete_pricing_model") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Delete</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="add_new_pricing_model"
                        checked={
                          role?.permissions?.includes(
                            "add_new_pricing_model",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">Add New</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Revenue Stat</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_revenue_stat"
                        checked={
                          role?.permissions?.includes("view_revenue_stat") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View Stat</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Driver Report</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_driver_report"
                        checked={
                          role?.permissions?.includes("view_driver_report") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">View Report</div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="export_driver_report"
                        checked={
                          role?.permissions?.includes("export_driver_report") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Export Report
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Ordable Integration</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_ordable_api_key"
                        checked={
                          role?.permissions?.includes("view_ordable_api_key") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View API Key
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="edit_ordable_api_key"
                        checked={
                          role?.permissions?.includes("edit_ordable_api_key") ??
                          false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Edit API Key
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_ordable_branch_keys"
                        checked={
                          role?.permissions?.includes(
                            "view_ordable_branch_keys",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Ordable Branch Keys
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="download_ordable_branch_keys"
                        checked={
                          role?.permissions?.includes(
                            "download_ordable_branch_keys",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Download Ordable Branch Keys
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="regenerate_ordable_branch_keys"
                        checked={
                          role?.permissions?.includes(
                            "regenerate_ordable_branch_keys",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Regenerate Ordable Branch Keys
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_ordable_integration"
                        checked={
                          role?.permissions?.includes(
                            "view_ordable_integration",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Ordable Integration
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_ordable_integration"
                        checked={
                          role?.permissions?.includes(
                            "create_ordable_integration",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Create Ordable Integration
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="delete_ordable_integration"
                        checked={
                          role?.permissions?.includes(
                            "delete_ordable_integration",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Delete Ordable Integration
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <p className="text-gray-900 mb-3">Bookeey Integration</p>
                <div className="row">
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="view_bookeey_integration"
                        checked={
                          role?.permissions?.includes(
                            "view_bookeey_integration",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          View Bookeey Integration
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-auto mb-3">
                    <div className="form-check form-check-sm">
                      <input
                        value="create_bookeey_integration"
                        checked={
                          role?.permissions?.includes(
                            "create_bookeey_integration",
                          ) ?? false
                        }
                        onChange={(e) => {
                          processData("permissions", e, "permissions");
                        }}
                        className="form-check-input me-3"
                        type="checkbox"
                      />
                      <label className="form-check-label">
                        <div className="fw-bold text-gray-800">
                          Update Bookeey Integration
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={() => {
                setRole({});
                setPopup("");
                setError({});
              }}
              type="button"
              className="btn btn-light btn-sm"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light btn-sm"
              onClick={() => action(popup)}
            >
              {popup === "add" ? "Add" : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigureRoleForm;